import { render, staticRenderFns } from "./section-steps.vue?vue&type=template&id=0df74c22&scoped=true"
import script from "./section-steps.vue?vue&type=script&lang=js"
export * from "./section-steps.vue?vue&type=script&lang=js"
import style0 from "./section-steps.vue?vue&type=style&index=0&id=0df74c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df74c22",
  null
  
)

export default component.exports